export default () => ({
  activeClientsById: {},
  users: {},
  currentUserId: window.currentUserId,
  sponsorships: [],
  sponsors: [],
  ratings: [],
  clients: [],
  clientsById: {},
  placements: [],
  engagements: [],
  engagementsById: {},
  featuresByKey: {},
  skills: [],
  staffingRoles: [],
  staffingRolesById: {},
  titles: [],
})
